import ScheduleMonth from './ScheduleCard.jsx'
import ScheduleYear from './ScheduleCardYear.jsx'
import ScrollToTopOnMount from '../MainContents/AutoScrollTop'; 
import styled from 'styled-components';


const MarginTop = styled.div`
    margin:0 auto;
    width:90%;
    margin-top: 140px;
`;
// 現塾生向けのページ
// メディアの内容を掲載する
const Information = () => {
    return (
        <MarginTop>
        <ScrollToTopOnMount />

            {/* 年間スケジュール 2025年 */}
            <ScheduleYear Year={'2025年'} title={'行事予定表'} />

            <ScheduleMonth
               Month={'2月'} Path="../Schedule202502.pdf"
               Month2={'1月'} Path2="../Schedule202501.pdf"
            //    Month3={'10月'} Path3="../Schedule202410.pdf"
            />

            <ScheduleYear Year={'2024年'} title={'行事予定表'} />
            <ScheduleMonth
               Month={'12月'} Path="../Schedule202412.pdf"
               Month2={'11月'} Path2="../Schedule202411.pdf"
               Month3={'10月'} Path3="../Schedule202410.pdf"
            />

            <ScheduleMonth
               Month={'9月'} Path="../Schedule202409.pdf"
               Month2={'8月'} Path2="../Schedule202408.pdf"
               Month3={'7月'} Path3="../Schedule202407.pdf"
            />

            <ScheduleMonth
               Month={'6月'} Path="../Schedule202406.pdf"
               Month2={'5月'} Path2="../Schedule202405.pdf"
               Month3={'4月'} Path3="../Schedule202404.pdf"
            />
            <ScheduleMonth
               Month={'3月'} Path="../Schedule202403.pdf"
               Month2={'2月'} Path2="../Schedule202402.pdf"
               Month3={'1月'} Path3="../Schedule202401.pdf"
            />


            {/* 小6 成績推移表*/}
            <ScheduleYear title={'土佐塾模試 成績推移表'} id="transition_table"/>
            <ScheduleMonth 
                Month={'４YTコース成績推移表(2023年)'} Path={'../transition2023Y4.pdf'}
                Month2={'４YTコース成績推移表(2022年)'} Path2={'../transition2022Y4.pdf'}
                Month3={'４YTコース成績推移表(2021年)'} Path3={'../transition2021Y4.pdf'}
            />
            <ScheduleMonth 
                Month={'５YTコース成績推移表(2023年)'} Path={'../transition2023Y5.pdf'}
                Month2={'５YTコース成績推移表(2022年)'} Path2={'../transition2022Y5.pdf'}
                Month3={'５YTコース成績推移表(2021年)'} Path3={'../transition2021Y5.pdf'}
            />
            <ScheduleMonth 
                Month={'６YTコース成績推移表(2023年)'} Path={'../transition2023Y6.pdf'}
                Month2={'６YTコース成績推移表(2022年)'} Path2={'../transition2022Y6.pdf'}
                Month3={'６YTコース成績推移表(2021年)'} Path3={'../transition2021Y6.pdf'}
            />
            <ScheduleMonth 
                Month={'６YTコース成績推移表(2020年)'} Path={'../transitionY6.pdf'}
            />


            {/*  */}

            {/* 平成３０年度入試動向*/}
            <ScheduleYear title={'入試情報'} />
            <ScheduleMonth Month={'2018年度(県内)入試動向'} Path={'../examinationTrend.jpg'}
                           Month2={'四国四県＋関西(四雄) 進学校大学合格状況'} Path2={'../successYT.pdf'}
            />
            
            {/*  */}

        </MarginTop>
    );
}

export default Information;